import { FilterBase } from '@myapp/modules/forms/models';

export class ModuleFilter extends FilterBase {

  GetFilter(inputValue: string) {
    return {
      filter: {
        logic: "or",
        filters: [
          {
            field: "name",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "description",
            operator: "contains",
            value: inputValue,
          },
        ],
      }
    };
  }
}
